module.exports = __webpack_public_path__ + "images/dinein-icon.b9fb8e2870f17ec9805ab273d23d48f3.gif";


//////////////////
// WEBPACK FOOTER
// ./img/dinein-icon.gif
// module id = 740
// module chunks = 0